import {configureStore} from "@reduxjs/toolkit";
import challengesReducer from "./ChallengeDataSlice"; // Import your slice

const store = configureStore({
  reducer: {
    challengesData: challengesReducer,
  },
});

export default store;
